export default "__VITE_ASSET__8045602c__"